import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MetaVision from './components/MetaVision';
import About from './components/About';
import CoreTech from './components/CoreTech';
import NetworkEvolution from './components/NetworkEvolution';
import XRExperience from './components/XRExperience';
import DigitalEconomy from './components/DigitalEconomy';
import VideoSection from './components/VideoSection';
import MarsCity from './components/MarsCity';
import LunarExploration from './components/LunarExploration';
import DigitalAssets from './components/DigitalAssets';
import FutureTech from './components/FutureTech';
import NexusRobot from './components/NexusRobot';
import MetaShop from './components/MetaShop';
import FutureVision from './components/FutureVision';
import FrontierTraining from './components/FrontierTraining';
import DeveloperEcosystem from './components/DeveloperEcosystem';
import Partners from './components/Partners';
import NewsTimeline from './components/NewsTimeline';
import ColumnEditor from './components/ColumnEditor';
import BBS from './components/BBS';
import FriendLinks from './components/FriendLinks';
import Footer from './components/Footer';
import MetaPioneers from './components/MetaPioneers';
import RobotAssistant from './components/RobotAssistant';

export default function HomePage() {
  const [lang, setLang] = useState<'zh' | 'en'>('zh');

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://meta66.cn';
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'META66',
        url: siteUrl,
        description: 'META66 — 引领元宇宙、6G超连接、Web5.0、XR沉浸体验与数字孪生的科技创新平台',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'META66',
        url: siteUrl,
        logo: `${siteUrl}/logo.png`,
        description: 'META66是专注于元宇宙、6G超连接、Web5.0、XR沉浸体验、数字孪生与量子加密的科技创新平台。',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '大湾区',
          addressCountry: 'CN',
          streetAddress: '清鉴META大厦',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-138-1000-1256',
          email: '13810001256@126.com',
          contactType: 'customer service',
          availableLanguage: ['Chinese', 'English'],
        },
      },
    ];

    const existingScript = document.getElementById('schema-org-jsonld');
    if (existingScript) existingScript.remove();
    const script = document.createElement('script');
    script.id = 'schema-org-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-org-jsonld');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#020810]" style={{ fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <Navbar lang={lang} onLangToggle={() => setLang((l) => (l === 'zh' ? 'en' : 'zh'))} />

      {/* 1. Hero - 首屏震撼入场 */}
      <Hero lang={lang} />

      {/* 2. MetaVision - 元宇宙愿景重磅开篇 */}
      <MetaVision />

      {/* 3. About - 关于META66 */}
      <About lang={lang} />

      {/* 4. CoreTech - 核心技术矩阵 */}
      <CoreTech lang={lang} />

      {/* 5. NetworkEvolution - 网络演进 */}
      <NetworkEvolution />

      {/* 6. XRExperience - XR沉浸体验 */}
      <XRExperience />

      {/* 7. DigitalEconomy - 数字经济 */}
      <DigitalEconomy />

      {/* 8. VideoSection - 影像志 */}
      <VideoSection />

      {/* 9. MarsCity - 火星城市互动板块 */}
      <MarsCity />

      {/* 9.5 LunarExploration - 月球探索板块 */}
      <LunarExploration />

      {/* 10. DigitalAssets - 数字资产/无证件时代 */}
      <DigitalAssets />

      {/* 11. FutureTech - 前沿科技连载故事 */}
      <FutureTech />

      {/* 12. NexusRobot - NEXUS-1人形机器人 */}
      <NexusRobot />

      {/* 12.5 MetaShop - 元宇宙超级商城 */}
      <MetaShop />

      {/* 13. FutureVision - 未来展望纪元 */}
      <FutureVision />

      {/* 14. FrontierTraining - 前沿培训 */}
      <FrontierTraining />

      {/* 15. DeveloperEcosystem - 开发者生态 */}
      <DeveloperEcosystem />

      {/* 16. Partners - 生态伙伴 */}
      <Partners />

      {/* 17. NewsTimeline - 元宇宙时讯 */}
      <NewsTimeline />

      {/* 18. ColumnEditor - 站长专栏 */}
      <ColumnEditor />

      {/* 18.5 MetaPioneers - META人物志 */}
      <MetaPioneers />

      {/* 19. BBS - 元界星图论坛 */}
      <BBS />

      {/* 20. FriendLinks - 友情链接 */}
      <FriendLinks />

      {/* Footer */}
      <Footer />

      {/* NOVA-X 飞行助手 */}
      <RobotAssistant />
    </div>
  );
}
